'use client';

import {
  gtmDataLayerEvent,
  type GtmItemListId,
  mapProductToGtmItem,
} from '~/utils/gtm/gtm-helpers';
import { InlineLink, type InlineLinkProps } from '../common/inline-link';
import { type components } from '~/fecom-api/schema';

interface ProductInlineLinkProps extends InlineLinkProps {
  sliLogUrl?: string | null;
  product: components['schemas']['Product'];
  gtmListId?: GtmItemListId;
  gtmListName?: string;
}

export function ProductInlineLink({
  sliLogUrl,
  product,
  gtmListId = 'plp',
  gtmListName = 'Product List',
  ...props
}: Readonly<ProductInlineLinkProps>) {
  const handleTracking = () => {
    if (sliLogUrl) {
      void fetch(sliLogUrl).catch((error) => {
        console.log('Error logging SLI click:', error);
      });
    }

    const item = mapProductToGtmItem({
      product,
      quantity: product.minOrderQuantity ?? 1,
    });
    gtmDataLayerEvent({
      event: 'select_item',
      ecommerce: {
        item_list_id: gtmListId,
        item_list_name: gtmListName,
        items: item ? [item] : [],
      },
    });
  };

  return (
    <InlineLink
      {...props}
      onClick={() => {
        handleTracking();
      }}
      onAuxClick={() => {
        handleTracking();
      }}
    />
  );
}
